import { CarPickerData } from './car-picker.model';
import { AddressModels } from './address.models';
import { CommonModels } from './common.models';
import { DateModels } from './date.models';
import { QuotationModels } from './quotation.models';
export namespace DocumentModels {
  /** Documents  */
  import HealthAvenantType = CommonModels.HealthAvenantType;

  export enum DocumentType {
    Orias = 1,
    CarteGrise = 2,
    KBIS = 3,
    JustificatifDomicilie = 4,
    RibIban = 5,
    AgencyContract = 6,
    SignedAgencyContract = 7,
    Unassigned = 8,
    Others = 9,
    Quotation = 10,
    Attestation = 11,
    PermisDeConduire = 12,
    ReleveInformation = 13,
    ConditionsGenerales = 14,
    CarteVerte = 15,
    ConditionsParticulieres = 16,
    AgencySlip = 17,
    NoticeLetter = 18,
    Sinister = 19,
    ReleveInformationTunnelSante = 20,
    TerminationRequest = 21,
    TerminationReject = 22,
    TerminationLetter = 23,
    AvenantRequest = 24,
    RemiseEnVigueurLetter = 25,
    TableauDeGaranties = 26,
    NoticeInformation = 27,
    MembershipApplication = 28,
    FicheIpid = 29,
    SignedMembershipApplication = 30,
    ConsultingSheet = 31,
    HealthSocialSecurityCertificate = 32,
    SubscriptionCertificate = 33,
    CarteIdentite = 34,
    RenewalNotice = 35,
    RenewalReject = 36,
    AgencySlipRecap = 37,
    AgencySlipEbics = 38,
    BordereauComptableSante = 39,
    AvenantReject = 40,
    SignedQuotation = 41,
    PhotoVehicule = 42,
    InsurerSlipRecap = 43,
    SignedAutoCp = 44,
    AssentimentMadelinAdherentTNS = 45,
    DontActe = 46,
    DeclarationFiscale = 47,
    Echeancier = 48,
    CarteVerteFondVert = 49,
    Lettre = 50,
    HealthAvenant = 51,
    ThirdPartyPayerCard = 52,
    BankReject = 53,
    DueNotice = 54,
    LoiMadelin = 55,
    RadiationCertification = 56,
    StatusChangeLetter = 57,
    MandatSepa = 58,
    Proto = 59,
    MandatResiliationPolicy = 60,
    SignedMandatResiliationPolicy = 61,
  }

  export interface File {
    id: number;
    name: string;
  }

  export interface Fragment {
    id: number;
    state: FragmentStateEnum;
    file: File;
    creationDate?: Date;
    printDate?: Date;
  }

  export interface Document {
    id: number;
    type: DocumentType;
    state: DocumentStateEnum;
    fragments: Fragment[];
  }

  export interface DocumentTypeObj {
    id: DocumentType;
    name: string;
    label: string;
    brokerVisible?: boolean;
  }

  export enum FragmentStateEnum {
    IsLoading = -1,
    NotHandled = 1,
    Handled = 2,
    Rejected = 3,
  }

  export enum DocumentStateEnum {
    Full = 1,
    Incomplete = 2,
    ToProcess = 3,
    NotFound = 4,
    Archived = 5,
  }

  // tslint:disable-next-line:no-empty-interface
  export interface DocumentInformation {}

  export interface OriasInformation extends DocumentInformation {
    rcs: string;
    city: string;
    registrationNumber: string;
    civilResponsabilityEndValidity: string;
  }

  export interface HealthAvenantInformation extends DocumentInformation {
    type: HealthAvenantType;
    effectDate: Date;
  }

  export interface RibInformation extends DocumentInformation {
    iban: string;
    bic?: string;
    firstNameHolder: string;
    lastNameHolder: string;
    civilityHolder: number;
    bankName: string;
    address: AddressModels.Address;
  }

  export interface KbisInformation extends DocumentInformation {
    companyName: string;
    companyType: CommonModels.CompanyTypeEnum;
    editionDate: string;
    capital: number;
    address: AddressModels.Address;
    lastNameRepresentative: string;
    firstNameRepresentative: string;
    function: string;
  }

  export interface LicenseInformation extends DocumentInformation {
    datePermis: string;
    dateNaissance: string;
    typePermis: QuotationModels.TypePermisEnum;
  }

  export interface CarteGriseInformation extends DocumentInformation {
    titulaireCarteGrise: QuotationModels.TitulaireCarteGriseEnum;
    car: CarPickerData;
  }

  export interface ReleveInformationInformation {
    nombreAnneeAssurance: number;
    nombreAnneeBonus50?: number;
    bonus: number;
    periode36Mois: QuotationModels.PeriodeAssurance36DerniersMoisEnum;
    periodeInterruption: QuotationModels.PeriodeInterruptionEnum;
    raisonResiliation: QuotationModels.RaisonResiliationEnum;
    periodes: DateModels.Range[];
  }

  // V2

  export interface PredefinedReject extends CustomReject {
    id: number;
  }

  export interface CustomReject {
    message: string;
    active: boolean;
  }

  export interface Fragment2 {
    id: number;
    state: FragmentStateEnum;
    fileName: string;
    downloadKey: string;
    creationDate: Date;
    printDate?: Date;
    brokerVisible: boolean;
    printRequest?: boolean;
    registerLetterExecutionDate?: Date;
  }

  export interface Document2 {
    hasRequiresAction?: boolean;
    id: number;
    type: DocumentType;
    state: DocumentStateEnum;
    fragments: Fragment2[];
    data: DocumentInformation;
    customRejects: CustomReject[];
    predefinedRejects: PredefinedReject[];
    allRejects: string[];
    expanded?: boolean;
    displayOrder?: number;
  }

  export interface DocumentFormData {
    documentId: number;
    documentType: number;
    state: DocumentStateEnum;
    data: DocumentInformation;
    customRejects: CustomReject[];
    predefinedRejects: PredefinedReject[];
  }

  export interface PatchFragment {
    newDocumentId?: number;
    newFragmentState?: number;
    newBrokerVisibleStatus?: boolean;
    newPrintRequestStatus?: boolean;
  }

  export interface DocumentsRequest {
    types?: DocumentType[];
  }

  export interface FragmentData {
    id: number;
    url: string;
    name: string;
  }
}
